import $ from 'jquery'

// Optional: make it available globally
window.$ = $
window.jQuery = $